import { render, staticRenderFns } from "./PurchaseOrderDelivery.vue?vue&type=template&id=c0d90984"
import script from "./PurchaseOrderDelivery.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports